/**
 * postaListeleriService.js — E-posta › Posta listeleri (backlog #585, backend MailListController, /email/lists):
 * Kullanıcılar listesinin süzgeciyle kullanıcıları süzüp bir posta listesi kurmak, listeye üye eklemek / çıkarmak ve listeye bir posta yazıp göndermek.
 *   · GET  /email/lists, GET / PUT / DELETE /email/lists/{id}, POST /email/lists                    → listeler (oluşturan ya da Sistem Ayarları yetkilisi değiştirir: 403)
 *   · GET  /email/lists/{id}/members, POST /email/lists/{id}/members, POST /email/lists/{id}/members/remove → üyeler (kullanıcı kimlikleri; adres gönderimde okunur)
 *   · POST /email/lists/filter-preview                                                              → bir süzgeç kaç kişiyi bulur (yazmaz)
 *   · GET  /email/lists/{id}/send/preview, POST /email/lists/{id}/send                              → önizleme (yazmaz) ve gönderim (iş: 202)
 *   · GET / DELETE /email/list-sends/{jobId}                                                        → işin ilerlemesi / durdurma
 * Süzgeç gövdesi Kullanıcılar listesinin KENDİ süzgeci (kullaniciListe.topluAktivasyonParametreleri): sunucu kümeyi kendisi kurar, istemci kimlik listesi
 * göndermez. Hata mesajı backend'in `message` alanıdır (isteğin dilinde); yoksa HTTP / ağ hatası metni.
 */
import axios from 'axios';
import { JAVA_BACKEND_API_URL, getAuthHeader } from '../Components/Contexts/BackendConstants';
import { emailHatasi } from './emailAyarService';

const BASE = `${JAVA_BACKEND_API_URL}/email`;

async function cagir(istek) {
  try {
    const response = await istek();
    return response.data;
  } catch (error) {
    throw emailHatasi(error);
  }
}

/** Süzgeç nesnesinden boş değerleri atar: sunucu boş metni "yok" sayar ama gövde okunur kalsın. */
export function suzgecGovdesi(suzgec) {
  const out = {};
  Object.entries(suzgec || {}).forEach(([k, v]) => {
    if (v !== '' && v !== null && v !== undefined) out[k] = v;
  });
  return out;
}

export function listMailLists({ page = 1, limit = 10, search = '' } = {}) {
  return cagir(() => axios.get(`${BASE}/lists`, { params: { page, limit, search }, headers: getAuthHeader() }));
}

export function getMailList(id) {
  return cagir(() => axios.get(`${BASE}/lists/${id}`, { headers: getAuthHeader() }));
}

/** { name, note?, filter?, userIds? } → 201 listenin kendisi (member_count, without_address, inactive, can_edit). */
export function createMailList(body) {
  return cagir(() => axios.post(`${BASE}/lists`, body, { headers: getAuthHeader() }));
}

export function updateMailList(id, body) {
  return cagir(() => axios.put(`${BASE}/lists/${id}`, body, { headers: getAuthHeader() }));
}

export function deleteMailList(id) {
  return cagir(() => axios.delete(`${BASE}/lists/${id}`, { headers: getAuthHeader() }));
}

export function listMailListMembers(id, { page = 1, limit = 20, search = '' } = {}) {
  return cagir(() => axios.get(`${BASE}/lists/${id}/members`, { params: { page, limit, search }, headers: getAuthHeader() }));
}

/** { filter?, userIds? } → { added, member_count }. */
export function addMailListMembers(id, body) {
  return cagir(() => axios.post(`${BASE}/lists/${id}/members`, body, { headers: getAuthHeader() }));
}

/** → { removed, member_count }. */
export function removeMailListMembers(id, userIds) {
  return cagir(() => axios.post(`${BASE}/lists/${id}/members/remove`, { userIds }, { headers: getAuthHeader() }));
}

/** { matched, without_address, inactive, sample[10] } — liste kurmadan önce süzgecin sonucu. */
export function previewUserFilter(filter) {
  return cagir(() => axios.post(`${BASE}/lists/filter-preview`, { filter: suzgecGovdesi(filter) }, { headers: getAuthHeader() }));
}

/** { members, will_send, without_address, bad_address, duplicate_address, blocked_by_safe_mode, blocked_reason, max_per_job, too_many, running_job_id, sender_id, sender } */
export function previewListSend(id, senderId, systemMail) {
  // WAS (until 2026-10-30): params: senderId ? { senderId } : {}   — systemMail (ACTIVATION | FORGOT_PASSWORD) asks what sending that SYSTEM mail to the list would do
  const params = {};
  if (senderId) params.senderId = senderId;
  if (systemMail) params.systemMail = systemMail;
  return cagir(() => axios.get(`${BASE}/lists/${id}/send/preview`, { params, headers: getAuthHeader() }));
}

/** { senderId?, subject, html, subjectEn?, htmlEn?, confirmedCount } ya da { systemMail: ACTIVATION | FORGOT_PASSWORD, confirmedCount } (2026-10-30: her üyeye kendi yeni bağlantısıyla) → 202 işin durumu { jobId, state, total, ... }. */
export function sendToMailList(id, payload) {
  return cagir(() => axios.post(`${BASE}/lists/${id}/send`, payload, { headers: getAuthHeader() }));
}

/** { jobId, state RUNNING | DONE | CANCELLED | STOPPED, stoppedReason, total, processed, sent, failed, skipped, blocked, firstFailures[] } */
export function getListSendJob(jobId) {
  return cagir(() => axios.get(`${BASE}/list-sends/${jobId}`, { headers: getAuthHeader() }));
}

export function cancelListSendJob(jobId) {
  return cagir(() => axios.delete(`${BASE}/list-sends/${jobId}`, { headers: getAuthHeader() }));
}
